module.exports = __webpack_public_path__ + "img/bg.ac57a5a5.png";